import gsap from 'gsap'
import CustomEase from 'gsap/CustomEase'

const ease = CustomEase.create('custom1', 'M0,0 C0.496,0 0.098,1 1,1')

const preloaderLogoAnimation = () => {
  const preloaderLogo = document.getElementById('preloader-logo')
  const symbol = document.getElementById('bcimmo-168x24')
  const shortLoader = localStorage.getItem('shortLoader')

  if (!preloaderLogo || !symbol || shortLoader !== null)
    return new Promise(resolve => setTimeout(resolve, 500))
  localStorage.setItem('shortLoader', '')

  const paths = symbol.querySelectorAll('path')
  const tl = gsap.timeline()

  tl.fromTo(
    paths,
    {
      opacity: 0,
      translateX: 100,
    },
    {
      opacity: 1,
      translateX: 0,
      stagger: 0.2,
      duration: 1.7,
      ease,
    }
  )
  tl.to(preloaderLogo, {
    opacity: 0,
    duration: 0.3,
  })
  tl.to(
    preloaderLogo,
    {
      translateY: -100,
      duration: 1,
      ease,
    },
    '<'
  )

  preloaderLogo.classList.remove('invisible')

  return tl
}

export default preloaderLogoAnimation
